// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3hJD2","error":"Textarea_error__2m_T2","readonly":"Textarea_readonly__39gfh","disabled":"Textarea_disabled__37U-L"};